export const GET_ALL_PROFESSIONS = 'get_all_professions';
export const GET_SELECTED_BUSINESSES = 'get_selected_businesses';
export const FETCH_BUSINESS_USER = 'fetch_business_user';
export const FETCH_PROFESSION = 'fetch_profession';
export const FETCH_REVIEWS_BY_PROFESSION = 'fetch_reviews_by_profession';
export const FETCH_REVIEWS_BY_USER_ID = 'fetch_reviews_by_user_id';
